import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchDashboardSummary, fetchSecurityScore, fetchSeverityBreakdown, fetchThreatTimeline,
  fetchActiveIncidentsSummary, fetchLiveFeed
} from '../../services/api/dashboardService';

export const loadDashboard = createAsyncThunk('dashboard/loadAll', async () => {
  const [summary, score, severity, timeline, incidents, feed] = await Promise.all([
    fetchDashboardSummary(),
    fetchSecurityScore(),
    fetchSeverityBreakdown(),
    fetchThreatTimeline(),
    fetchActiveIncidentsSummary(),
    fetchLiveFeed(30)
  ]);
  return { summary, score, severity, timeline, incidents, feed };
});

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    status: 'idle', // idle | loading | succeeded | failed
    error: null,
    summary: null,
    score: null,
    severityBreakdown: [],
    timeline: [],
    incidents: [],
    liveFeed: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadDashboard.pending, (state) => { state.status = 'loading'; })
      .addCase(loadDashboard.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.summary = action.payload.summary;
        state.score = action.payload.score;
        state.severityBreakdown = action.payload.severity;
        state.timeline = action.payload.timeline;
        state.incidents = action.payload.incidents;
        state.liveFeed = action.payload.feed;
      })
      .addCase(loadDashboard.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export default dashboardSlice.reducer;
